$(function() {
    "use strict";


    $(document).ready(function() {

        var $root = $('.peppermint');

        if ($root.length > 0) {

            $root.each(function() {
                var $slider = $(this),
                    $prev   = $slider.find('.peppermint__prev'),
                    $next   = $slider.find('.peppermint__next');

                $slider
                .data('Peppermint:prev', $prev)
                .data('Peppermint:next', $next);

                $prev.remove();
                $next.remove();

                $slider
                .Peppermint({
                    onSlideChange: function() {
                        $slider.trigger('slideChange');
                    },
                    dots: Modernizr.touch
                });

                var Peppermint = $root.data('Peppermint');
                if (Peppermint.getSlidesNumber() > 1) {
                    var allSlides = Peppermint.getSlidesNumber();

                    $slider.prepend($slider.data('Peppermint:prev'));
                    $prev = $slider.find('.peppermint__prev');
                    $prev.click(Peppermint.prev);
                    $slider.append($slider.data('Peppermint:next'));
                    $next = $slider.find('.peppermint__next');
                    $next.removeClass('peppermint__hidden').click(Peppermint.next);

                    $slider.on('slideChange', function() {
                        var currentSlide = Peppermint.getCurrentPos();

                        if (currentSlide < 1) {
                            $prev.addClass('peppermint__hidden');
                        }
                        else {
                            $prev.removeClass('peppermint__hidden');
                        }

                        if (currentSlide > allSlides - 2) {
                            $next.addClass('peppermint__hidden');
                        }
                        else {
                            $next.removeClass('peppermint__hidden');
                        }
                    });
                } else {
                    $slider.removeClass('peppermint-inactive');
                }
            });
        }
    });
});